window.moment = require('moment')
window.Quill = require('quill')



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/global.js